export default __webpack_public_path__ + "static/media/213.9ab61d3d.png";